import client from "../client";
import { QueryFunctionContext } from "@tanstack/react-query";
import appendQueryParams from "@/utils/appendQueryParams";

export function getTargetAccountFiles(data: QueryFunctionContext) {
  return client.get(
    appendQueryParams("/target-account/getFiles", data.meta?.queryParams ?? {})
  );
}
